module.exports = __webpack_public_path__ + "static/media/20210403_203729_111_IMG_0009.8ce67b78.jpg";